const fiscalGatewaySetupEn = {
  "fiscalGatewaySetup.actions.activate": "Activate",
  "fiscalGatewaySetup.actions.apply": "Apply",
  "fiscalGatewaySetup.actions.approve": "Approve",
  "fiscalGatewaySetup.actions.checkRouting": "Check routing",
  "fiscalGatewaySetup.actions.compare": "Compare",
  "fiscalGatewaySetup.actions.continueSetup": "Continue setup",
  "fiscalGatewaySetup.actions.disable": "Disable",
  "fiscalGatewaySetup.actions.import": "Import",
  "fiscalGatewaySetup.actions.openBackendHealth": "Open backend health",
  "fiscalGatewaySetup.actions.openBusinessProfile": "Open profile",
  "fiscalGatewaySetup.actions.openCatalogPublication": "Review publication",
  "fiscalGatewaySetup.actions.openDiagnostics": "Show technical details",
  "fiscalGatewaySetup.actions.openReceiptReadback": "Open receipt status",
  "fiscalGatewaySetup.actions.openReceiptRoute": "Set order route",
  "fiscalGatewaySetup.actions.openReceiptStatus": "View receipt status",
  "fiscalGatewaySetup.actions.openRetryQueue": "Open retry queue",
  "fiscalGatewaySetup.actions.openSourceSystem": "Open source system",
  "fiscalGatewaySetup.actions.preview": "Preview",
  "fiscalGatewaySetup.actions.refresh": "Refresh",
  "fiscalGatewaySetup.actions.refreshList": "Refresh list",
  "fiscalGatewaySetup.actions.reset": "Reset",
  "fiscalGatewaySetup.actions.runDryRun": "Run dry-run",
  "fiscalGatewaySetup.actions.runImport": "Run import",
  "fiscalGatewaySetup.actions.saveIntegration": "Save integration",
  "fiscalGatewaySetup.actions.saveRoute": "Save route",
  "fiscalGatewaySetup.actions.syncExistingSetup": "Sync existing setup",
  "fiscalGatewaySetup.actions.test": "Test",
  "fiscalGatewaySetup.actions.testTableServiceReceipt": "Test Table Service receipt",
  "fiscalGatewaySetup.actions.useAsTemplate": "Use as template",
  "fiscalGatewaySetup.a11y.nextSetupAction": "Next setup action",
  "fiscalGatewaySetup.a11y.openMobileActions": "Open Venue Bridge actions",
  "fiscalGatewaySetup.backfill.cardLabels.generated": "Generated",
  "fiscalGatewaySetup.backfill.cardLabels.sourceHash": "Source hash",
  "fiscalGatewaySetup.backfill.cardLabels.sourceVersion": "Source version",
  "fiscalGatewaySetup.backfill.counts.devices": "Devices",
  "fiscalGatewaySetup.backfill.counts.locations": "Locations",
  "fiscalGatewaySetup.backfill.counts.merchants": "Merchants",
  "fiscalGatewaySetup.backfill.counts.posConnections": "POS connections",
  "fiscalGatewaySetup.backfill.counts.routeFlags": "Route flags",
  "fiscalGatewaySetup.backfill.description": "Venue Bridge import freshness, source hashes and product-local projections.",
  "fiscalGatewaySetup.backfill.errors.loadPreview": "Failed to load backfill preview",
  "fiscalGatewaySetup.backfill.errors.requestFailed": "Import request failed",
  "fiscalGatewaySetup.backfill.errors.runBackfill": "Failed to run backfill",
  "fiscalGatewaySetup.backfill.fields.directoryMerchant": "Directory merchant",
  "fiscalGatewaySetup.backfill.fields.limit": "Limit",
  "fiscalGatewaySetup.backfill.fields.sourceMerchant": "Source merchant",
  "fiscalGatewaySetup.backfill.lastImport.description": "Completed {completedAt} with {count} projection upserts.{connectorSummary}",
  "fiscalGatewaySetup.backfill.lastImport.connectorSummary": " Connectors: {created} created, {updated} updated, {unchanged} unchanged.",
  "fiscalGatewaySetup.backfill.lastImport.title": "Last import result",
  "fiscalGatewaySetup.backfill.placeholders.directoryId": "directory id",
  "fiscalGatewaySetup.backfill.placeholders.merchantId": "merchant id",
  "fiscalGatewaySetup.backfill.projectionGroups.connectors": "Connectors",
  "fiscalGatewaySetup.backfill.projectionGroups.devices": "Devices",
  "fiscalGatewaySetup.backfill.projectionGroups.locations": "Locations",
  "fiscalGatewaySetup.backfill.projectionGroups.merchants": "Merchants",
  "fiscalGatewaySetup.backfill.projectionGroups.operators": "Operators",
  "fiscalGatewaySetup.backfill.projectionGroups.taxpayers": "Taxpayers",
  "fiscalGatewaySetup.backfill.projectedRows": "{count} projected rows",
  "fiscalGatewaySetup.backfill.projectionEmpty": "No projection rows.",
  "fiscalGatewaySetup.backfill.projectionImported": "imported {value}",
  "fiscalGatewaySetup.backfill.projectionRecord": "Projection row",
  "fiscalGatewaySetup.backfill.scopeManaged": "Import runs against the synced setup. Merchant and Place scope is resolved from Venue Bridge context, not typed manually.",
  "fiscalGatewaySetup.backfill.title": "Existing Setup Import",
  "fiscalGatewaySetup.backfill.warnings": "Warnings",
  "fiscalGatewaySetup.common.active": "active",
  "fiscalGatewaySetup.common.all": "All",
  "fiscalGatewaySetup.common.emptyValue": "-",
  "fiscalGatewaySetup.common.loadedCount": "{count} loaded",
  "fiscalGatewaySetup.common.total": "{count} total",
  "fiscalGatewaySetup.boundary.a3Pay.detail": "A3 Pay accepts PaymentRequest, executes PSP/provider flows and stores payment, risk, dispute, safeguarding and remittance state. It does not calculate split formulas.",
  "fiscalGatewaySetup.boundary.a3Pay.title": "A3 Pay owns payment execution",
  "fiscalGatewaySetup.boundary.coopPlatform.detail": "Coop Platform resolves access through Core Registry and opens Venue Bridge runtime actions, but does not own connector setup, routing workflow or gateway status mapping.",
  "fiscalGatewaySetup.boundary.coopPlatform.title": "Coop Platform is the control plane",
  "fiscalGatewaySetup.boundary.fiscalGateway.detail": "Venue Bridge receives Table Service receipt requests, selects the target backend, routes submissions, normalizes status/readback, manages retries and exports transmission evidence. It does not issue certified fiscal receipts.",
  "fiscalGatewaySetup.boundary.fiscalGateway.title": "Venue Bridge owns routing and readback",
  "fiscalGatewaySetup.boundary.tableService.detail": "A3 Table Service owns guest flow and product-local projections for Merchant, Place, menu, cart, order, payment refs and fiscal refs.",
  "fiscalGatewaySetup.boundary.tableService.title": "A3 Table Service owns the guest flow",
  "fiscalGatewaySetup.connectors.advanced.config": "Additional connection config",
  "fiscalGatewaySetup.connectors.advanced.hide": "Hide advanced settings",
  "fiscalGatewaySetup.connectors.advanced.show": "Advanced settings",
  "fiscalGatewaySetup.connectors.cards.configured": "Configured",
  "fiscalGatewaySetup.connectors.cards.endpoint": "Endpoint",
  "fiscalGatewaySetup.connectors.cards.credentials": "Credentials",
  "fiscalGatewaySetup.connectors.cards.forMerchant": "{provider} for {merchant}",
  "fiscalGatewaySetup.connectors.cards.lastTest": "Last test",
  "fiscalGatewaySetup.connectors.cards.managedByA3": "Managed by A3 setup",
  "fiscalGatewaySetup.connectors.cards.notConfigured": "Not configured",
  "fiscalGatewaySetup.connectors.cards.paymentType": "Payment type",
  "fiscalGatewaySetup.connectors.cards.restaurant": "POS organization",
  "fiscalGatewaySetup.connectors.cards.terminal": "Terminal/register group",
  "fiscalGatewaySetup.connectors.cards.menu": "Menu",
  "fiscalGatewaySetup.connectors.cards.technicalDetails": "Technical details",
  "fiscalGatewaySetup.connectors.cards.updatedRevision": "Updated {updatedAt} - revision {revision}",
  "fiscalGatewaySetup.connectors.cards.webhook": "Webhook",
  "fiscalGatewaySetup.connectors.capabilities.catalogPublication": "Catalog publication",
  "fiscalGatewaySetup.connectors.capabilities.customOperations": "Custom operations",
  "fiscalGatewaySetup.connectors.capabilities.deviceRoute": "Device route",
  "fiscalGatewaySetup.connectors.capabilities.evidence": "Evidence export",
  "fiscalGatewaySetup.connectors.capabilities.fiscalStatus": "Fiscal status",
  "fiscalGatewaySetup.connectors.capabilities.health": "Health check",
  "fiscalGatewaySetup.connectors.capabilities.orders": "Orders",
  "fiscalGatewaySetup.connectors.capabilities.paymentClose": "Payment close",
  "fiscalGatewaySetup.connectors.capabilities.posReadback": "POS readback",
  "fiscalGatewaySetup.connectors.capabilities.reconciliation": "Reconciliation",
  "fiscalGatewaySetup.connectors.capabilities.registerEvidence": "Register evidence",
  "fiscalGatewaySetup.connectors.capabilities.registerReceipts": "Register receipts",
  "fiscalGatewaySetup.connectors.currentScope.active": "active",
  "fiscalGatewaySetup.connectors.currentScope.allMerchants": "All merchants",
  "fiscalGatewaySetup.connectors.currentScope.guidance": "Start with one tested connection; add more only when a venue needs separate POS or register channels.",
  "fiscalGatewaySetup.connectors.currentScope.integrations": "integrations",
  "fiscalGatewaySetup.connectors.currentScope.needsConnection": "Add a POS/register connection.",
  "fiscalGatewaySetup.connectors.currentScope.needsTest": "Run a connection test.",
  "fiscalGatewaySetup.connectors.currentScope.ready": "Ready for order route.",
  "fiscalGatewaySetup.connectors.currentScope.selectVenue": "Select a Merchant or Place to see readiness.",
  "fiscalGatewaySetup.connectors.currentScope.title": "Current scope",
  "fiscalGatewaySetup.connectors.description": "Connect this venue to its external POS, A3 Fiscal Register or device backend. Technical IDs stay behind details.",
  "fiscalGatewaySetup.connectors.empty": "No integrations configured for this merchant scope.",
  "fiscalGatewaySetup.connectors.errors.advancedJsonInvalid": "Advanced JSON is invalid",
  "fiscalGatewaySetup.connectors.errors.loadIntegrations": "Failed to load integrations",
  "fiscalGatewaySetup.connectors.errors.loadMerchantList": "Failed to load merchant list",
  "fiscalGatewaySetup.connectors.errors.requestFailed": "Integration request failed",
  "fiscalGatewaySetup.connectors.errors.saveIntegration": "Failed to save integration",
  "fiscalGatewaySetup.connectors.errors.syncExistingSetup": "Failed to sync existing setup",
  "fiscalGatewaySetup.connectors.errors.testIntegration": "Failed to test integration",
  "fiscalGatewaySetup.connectors.errors.updateIntegration": "Failed to update integration",
  "fiscalGatewaySetup.connectors.fields.accessCredential": "Access credential",
  "fiscalGatewaySetup.connectors.fields.apiKey": "API key",
  "fiscalGatewaySetup.connectors.fields.backendCode": "Backend code",
  "fiscalGatewaySetup.connectors.fields.baseUrl": "Base URL",
  "fiscalGatewaySetup.connectors.fields.deviceEndpoint": "Device endpoint",
  "fiscalGatewaySetup.connectors.fields.directHost": "Direct host",
  "fiscalGatewaySetup.connectors.fields.directoryLocation": "Core Registry Place",
  "fiscalGatewaySetup.connectors.fields.directoryMerchant": "Directory merchant",
  "fiscalGatewaySetup.connectors.fields.externalMenu": "POS menu",
  "fiscalGatewaySetup.connectors.fields.initialState": "Initial state",
  "fiscalGatewaySetup.connectors.fields.integrationName": "Integration name",
  "fiscalGatewaySetup.connectors.fields.location": "Place",
  "fiscalGatewaySetup.connectors.fields.locationRef": "Place ref",
  "fiscalGatewaySetup.connectors.fields.menuVersion": "Menu version",
  "fiscalGatewaySetup.connectors.fields.merchant": "Merchant",
  "fiscalGatewaySetup.connectors.fields.merchantRef": "Merchant ref",
  "fiscalGatewaySetup.connectors.fields.paymentTypeId": "Payment type ref",
  "fiscalGatewaySetup.connectors.fields.paymentTypeKind": "Payment type kind",
  "fiscalGatewaySetup.connectors.fields.posRestaurantId": "POS organization or restaurant",
  "fiscalGatewaySetup.connectors.fields.posTerminalId": "Terminal or register group",
  "fiscalGatewaySetup.connectors.fields.priceCategory": "Price category",
  "fiscalGatewaySetup.connectors.fields.registerId": "Register ID",
  "fiscalGatewaySetup.connectors.fields.registerRef": "Register ref",
  "fiscalGatewaySetup.connectors.fields.serviceFeeProduct": "Service fee product",
  "fiscalGatewaySetup.connectors.fields.siteAgent": "Site agent",
  "fiscalGatewaySetup.connectors.fields.webhookToken": "Webhook token",
  "fiscalGatewaySetup.connectors.form.addDescription": "Choose how this venue talks to its POS, register or device backend. Start with one tested connection, then add separate routes only when needed.",
  "fiscalGatewaySetup.connectors.form.addTitle": "Add POS/register connection",
  "fiscalGatewaySetup.connectors.form.a3ChdManaged": "A3 CHD uses the selected Merchant/Place and synced device setup. No A3 device or agent IDs are entered here.",
  "fiscalGatewaySetup.connectors.form.a3RegisterManaged": "A3 Fiscal Register uses the selected Merchant/Place and synced register setup. No A3 register IDs are entered here.",
  "fiscalGatewaySetup.connectors.form.merchantSelected": "Merchant selected",
  "fiscalGatewaySetup.connectors.form.selectMerchantFirst": "Select merchant first",
  "fiscalGatewaySetup.connectors.form.sendTipsToPos": "Send tips to POS",
  "fiscalGatewaySetup.connectors.notices.connectionTest": "Connection test {status}.",
  "fiscalGatewaySetup.connectors.notices.existingSetupSynced": "Existing setup synced.",
  "fiscalGatewaySetup.connectors.notices.existingSetupSyncedCounts": "Existing setup synced. {created} created, {updated} updated, {unchanged} unchanged.",
  "fiscalGatewaySetup.connectors.notices.integrationAlreadyConfigured": "This integration already matches the saved configuration.",
  "fiscalGatewaySetup.connectors.notices.integrationAlreadyStatus": "Integration already had that status.",
  "fiscalGatewaySetup.connectors.notices.integrationSaved": "Integration saved.",
  "fiscalGatewaySetup.connectors.notices.integrationStatus": "Integration {status}.",
  "fiscalGatewaySetup.connectors.notices.updated": "Integrations updated",
  "fiscalGatewaySetup.connectors.nextAction.activateWhenReady": "Activate when setup is confirmed",
  "fiscalGatewaySetup.connectors.nextAction.enable": "Enable before routing",
  "fiscalGatewaySetup.connectors.nextAction.setOrderRoute": "Set order route",
  "fiscalGatewaySetup.connectors.nextAction.testConnection": "Test connection before route",
  "fiscalGatewaySetup.connectors.templateCopyName": "{name} copy",
  "fiscalGatewaySetup.connectors.placeholders.agentId": "agent id",
  "fiscalGatewaySetup.connectors.placeholders.directoryId": "directory id",
  "fiscalGatewaySetup.connectors.placeholders.exampleUrl": "https://api.example.com",
  "fiscalGatewaySetup.connectors.placeholders.menuId": "optional menu id",
  "fiscalGatewaySetup.connectors.placeholders.merchantId": "merchant id",
  "fiscalGatewaySetup.connectors.placeholders.optional": "optional",
  "fiscalGatewaySetup.connectors.placeholders.optionalDirectoryId": "optional directory id",
  "fiscalGatewaySetup.connectors.placeholders.optionalLocationId": "optional location id",
  "fiscalGatewaySetup.connectors.placeholders.optionalPriceCategory": "optional price category",
  "fiscalGatewaySetup.connectors.placeholders.optionalProductId": "optional product id",
  "fiscalGatewaySetup.connectors.placeholders.optionalRef": "optional ref",
  "fiscalGatewaySetup.connectors.placeholders.organizationId": "organization id",
  "fiscalGatewaySetup.connectors.placeholders.paymentKind": "Card / External",
  "fiscalGatewaySetup.connectors.placeholders.paymentTypeId": "payment type id",
  "fiscalGatewaySetup.connectors.placeholders.providerCode": "provider code",
  "fiscalGatewaySetup.connectors.placeholders.terminalGroupId": "terminal group id",
  "fiscalGatewaySetup.connectors.providers.a3Chd.defaultName": "A3 CHD",
  "fiscalGatewaySetup.connectors.providers.a3Chd.description": "A3-managed CHD runtime, device access and reconciliation.",
  "fiscalGatewaySetup.connectors.providers.a3Chd.label": "A3 CHD",
  "fiscalGatewaySetup.connectors.providers.a3FiscalRegister.defaultName": "A3 Fiscal Register",
  "fiscalGatewaySetup.connectors.providers.a3FiscalRegister.description": "A3-owned register for certified receipt execution after certification.",
  "fiscalGatewaySetup.connectors.providers.a3FiscalRegister.label": "A3 Fiscal Register",
  "fiscalGatewaySetup.connectors.providers.chdPm500.defaultName": "CHD PM500",
  "fiscalGatewaySetup.connectors.providers.chdPm500.description": "CHD PM500 device through site agent or direct endpoint.",
  "fiscalGatewaySetup.connectors.providers.chdPm500.label": "CHD PM500",
  "fiscalGatewaySetup.connectors.providers.customHttp.defaultName": "Other certified backend",
  "fiscalGatewaySetup.connectors.providers.customHttp.description": "Custom POS or register backend with managed credentials.",
  "fiscalGatewaySetup.connectors.providers.customHttp.label": "Other backend",
  "fiscalGatewaySetup.connectors.providers.syrvePos.defaultName": "Syrve POS",
  "fiscalGatewaySetup.connectors.providers.syrvePos.description": "Orders, menu, payment refs and webhook intake.",
  "fiscalGatewaySetup.connectors.providers.syrvePos.label": "Syrve POS",
  "fiscalGatewaySetup.connectors.readiness.draft": "Draft connection",
  "fiscalGatewaySetup.connectors.readiness.failed": "Test failed",
  "fiscalGatewaySetup.connectors.readiness.paused": "Paused",
  "fiscalGatewaySetup.connectors.readiness.ready": "Ready for routing",
  "fiscalGatewaySetup.connectors.readiness.testNeeded": "Test needed",
  "fiscalGatewaySetup.connectors.saved.descriptionAll": "Showing all configured integrations.",
  "fiscalGatewaySetup.connectors.saved.descriptionScoped": "Showing integrations for the selected merchant scope.",
  "fiscalGatewaySetup.connectors.saved.title": "Saved integrations",
  "fiscalGatewaySetup.connectors.scope.advancedRefsFallback": "Technical details",
  "fiscalGatewaySetup.connectors.scope.allLocations": "All Places",
  "fiscalGatewaySetup.connectors.scope.directoryProjectionReady": "Directory projection ready",
  "fiscalGatewaySetup.connectors.scope.directoryLocationLabel": "Core Registry Place {ref}",
  "fiscalGatewaySetup.connectors.scope.directoryMerchantLabel": "Directory merchant {ref}",
  "fiscalGatewaySetup.connectors.scope.existingSetup": "Existing setup",
  "fiscalGatewaySetup.connectors.scope.locationLabel": "Place {ref}",
  "fiscalGatewaySetup.connectors.scope.locationPrefix": "Place: {location}",
  "fiscalGatewaySetup.connectors.scope.manualLocation": "Manual Place",
  "fiscalGatewaySetup.connectors.scope.manualScope": "Manual scope",
  "fiscalGatewaySetup.connectors.scope.merchantListUnavailable": "Merchant list unavailable: {message}",
  "fiscalGatewaySetup.connectors.scope.merchantLabel": "Merchant {ref}",
  "fiscalGatewaySetup.connectors.scope.merchantSetup": "Merchant setup",
  "fiscalGatewaySetup.connectors.scope.noMerchantSelected": "No merchant selected",
  "fiscalGatewaySetup.connectors.scope.projection": "Projection",
  "fiscalGatewaySetup.connectors.scope.savedIntegration": "Saved integration",
  "fiscalGatewaySetup.connectors.scope.savedMerchantScope": "Saved merchant scope",
  "fiscalGatewaySetup.connectors.scope.savedPlaceScope": "Saved Place scope",
  "fiscalGatewaySetup.connectors.scope.selectMerchant": "Select merchant",
  "fiscalGatewaySetup.connectors.scope.selectMerchantFirst": "Select merchant first",
  "fiscalGatewaySetup.connectors.scope.loadingMerchants": "Loading merchants...",
  "fiscalGatewaySetup.connectors.scope.unnamedMerchant": "Unnamed merchant",
  "fiscalGatewaySetup.connectors.scope.unnamedPlace": "Unnamed Place",
  "fiscalGatewaySetup.connectors.title": "POS/Register Connection",
  "fiscalGatewaySetup.coopControlPlane.coreRegistry.description": "Core Registry owns user access, merchant entitlement, canonical Merchant/Place identity, taxpayer references and shared device/register refs. Venue Bridge receives this as scoped context.",
  "fiscalGatewaySetup.coopControlPlane.coreRegistry.title": "Core Registry context",
  "fiscalGatewaySetup.coopControlPlane.description": "Coop Platform shows readiness summary and opens Venue Bridge-owned runtime screens with Core Registry Merchant/Place context. Connector setup, routing, retry, readback and evidence stay in Venue Bridge.",
  "fiscalGatewaySetup.coopControlPlane.eyebrow": "Coop control plane",
  "fiscalGatewaySetup.coopControlPlane.gatewayRuntime.description": "Connector credentials, backend target selection, Table Service order/payment routes, retry/reconciliation, publication handoff issues and evidence export are maintained in Venue Bridge.",
  "fiscalGatewaySetup.coopControlPlane.gatewayRuntime.title": "Venue Bridge runtime state",
  "fiscalGatewaySetup.coopControlPlane.openRuntime": "Open Venue Bridge",
  "fiscalGatewaySetup.coopControlPlane.title": "Venue Bridge control plane",
  "fiscalGatewaySetup.diagnostics.mirror.detail": "Coop Platform sync and compatibility projection attention count.",
  "fiscalGatewaySetup.diagnostics.mirror.title": "Compatibility sync",
  "fiscalGatewaySetup.diagnostics.rollout.detail": "Production rollout gate status for regulated enablement.",
  "fiscalGatewaySetup.diagnostics.rollout.title": "Rollout gate",
  "fiscalGatewaySetup.diagnostics.routes.detail": "Configured receipt routing records available to advanced operators.",
  "fiscalGatewaySetup.diagnostics.routes.title": "Route records",
  "fiscalGatewaySetup.diagnostics.runtime.detail": "Product runtime health returned by the Venue Bridge API.",
  "fiscalGatewaySetup.diagnostics.runtime.title": "Runtime health",
  "fiscalGatewaySetup.diagnostics.values.notChecked": "Not checked",
  "fiscalGatewaySetup.diagnostics.values.pending": "Pending",
  "fiscalGatewaySetup.errors.loadOverviewBody": "The setup dashboard is using the data that is available now. Refresh again, or open technical details for support.",
  "fiscalGatewaySetup.errors.loadOverviewTitle": "Some Venue Bridge setup checks could not load",
  "fiscalGatewaySetup.errors.showTechnicalDetails": "Show technical details",
  "fiscalGatewaySetup.errors.technicalMessage": "Technical message",
  "fiscalGatewaySetup.errors.technicalTimestamp": "Time",
  "fiscalGatewaySetup.evidence.tabletDesktopRequired": "Tablet or desktop required",
  "fiscalGatewaySetup.evidence.tools.controlledChanges.action": "Open controlled changes",
  "fiscalGatewaySetup.evidence.tools.controlledChanges.detail": "Route cutover, connector credential changes, publication activation, conflict resolution and export approval stay protected by role checks and require a wider device.",
  "fiscalGatewaySetup.evidence.tools.controlledChanges.title": "Controlled changes",
  "fiscalGatewaySetup.evidence.tools.evidencePackage.action": "Open evidence",
  "fiscalGatewaySetup.evidence.tools.evidencePackage.detail": "Audit trail, backend refs, readback, Coop mirror and rollout evidence for support or compliance review.",
  "fiscalGatewaySetup.evidence.tools.evidencePackage.title": "Evidence package",
  "fiscalGatewaySetup.evidence.tools.publicationCompare.action": "Compare publication",
  "fiscalGatewaySetup.evidence.tools.publicationCompare.detail": "Catalog dry-run, compare, approval, activation and manifest evidence stay available after setup is stable.",
  "fiscalGatewaySetup.evidence.tools.publicationCompare.title": "Catalog compare",
  "fiscalGatewaySetup.evidence.tools.routeMatrix.action": "Open routing",
  "fiscalGatewaySetup.evidence.tools.routeMatrix.detail": "Merchant, Place and channel routing records for support operators who need the full order/payment route matrix.",
  "fiscalGatewaySetup.evidence.tools.routeMatrix.title": "Order route matrix",
  "fiscalGatewaySetup.header.mobileActions": "Actions",
  "fiscalGatewaySetup.header.pinnedSections": "{count} pinned",
  "fiscalGatewaySetup.header.productSubtitle": "Venue operations integration",
  "fiscalGatewaySetup.header.productConsole": "Product console",
  "fiscalGatewaySetup.header.productTitle": "A3 Venue Bridge",
  "fiscalGatewaySetup.header.readOnly": "Read-only",
  "fiscalGatewaySetup.header.sections": "Sections",
  "fiscalGatewaySetup.header.signOut": "Sign out",
  "fiscalGatewaySetup.intents.audit": "Audit",
  "fiscalGatewaySetup.intents.columns.correlation": "Correlation",
  "fiscalGatewaySetup.intents.columns.event": "Event",
  "fiscalGatewaySetup.intents.columns.merchant": "Merchant",
  "fiscalGatewaySetup.intents.columns.operation": "Operation",
  "fiscalGatewaySetup.intents.columns.payment": "Payment",
  "fiscalGatewaySetup.intents.columns.route": "Route",
  "fiscalGatewaySetup.intents.columns.routing": "Routing",
  "fiscalGatewaySetup.intents.columns.shadow": "Shadow",
  "fiscalGatewaySetup.intents.columns.source": "Source",
  "fiscalGatewaySetup.intents.columns.status": "Status",
  "fiscalGatewaySetup.intents.columns.time": "Time",
  "fiscalGatewaySetup.intents.columns.validation": "Validation",
  "fiscalGatewaySetup.intents.counts.drift": "{count} drift",
  "fiscalGatewaySetup.intents.counts.invalid": "{count} invalid",
  "fiscalGatewaySetup.intents.counts.pendingLabel": "Pending",
  "fiscalGatewaySetup.intents.counts.readyLabel": "Ready",
  "fiscalGatewaySetup.intents.counts.reviewLabel": "Review",
  "fiscalGatewaySetup.intents.description": "Track payment close, receipt status and register readback from Table Service and A3 Pay.",
  "fiscalGatewaySetup.intents.empty": "No payment or receipt operations found.",
  "fiscalGatewaySetup.intents.errors.loadDetail": "Failed to load Venue Bridge operation",
  "fiscalGatewaySetup.intents.errors.loadList": "Failed to load Venue Bridge operations",
  "fiscalGatewaySetup.intents.eyebrow": "Daily operations",
  "fiscalGatewaySetup.intents.filters.correlation": "Correlation",
  "fiscalGatewaySetup.intents.filters.merchantId": "Merchant",
  "fiscalGatewaySetup.intents.filters.routing": "Routing",
  "fiscalGatewaySetup.intents.filters.shadow": "Shadow",
  "fiscalGatewaySetup.intents.filters.source": "Source product",
  "fiscalGatewaySetup.intents.filters.technical": "Technical filters",
  "fiscalGatewaySetup.intents.filters.validation": "Validation",
  "fiscalGatewaySetup.intents.loadingIntent": "Loading intent",
  "fiscalGatewaySetup.intents.operationStates.pending": "Pending",
  "fiscalGatewaySetup.intents.operationStates.ready": "Ready",
  "fiscalGatewaySetup.intents.operationStates.review": "Review",
  "fiscalGatewaySetup.intents.operations.orderRoute": "Order route",
  "fiscalGatewaySetup.intents.operations.paymentClose": "Payment close",
  "fiscalGatewaySetup.intents.operations.receiptStatus": "Receipt status",
  "fiscalGatewaySetup.intents.operations.registerOperation": "Register operation",
  "fiscalGatewaySetup.intents.payload": "Payload",
  "fiscalGatewaySetup.intents.receiptRequestTitle": "Operation details {id}",
  "fiscalGatewaySetup.intents.routes.a3Register": "A3 Fiscal Register",
  "fiscalGatewaySetup.intents.routes.chd": "CHD/device route",
  "fiscalGatewaySetup.intents.routes.externalPos": "{provider} route",
  "fiscalGatewaySetup.intents.routes.notSelected": "Route not selected",
  "fiscalGatewaySetup.intents.scope.merchant": "Merchant {ref}",
  "fiscalGatewaySetup.intents.scope.notProvided": "Merchant not provided",
  "fiscalGatewaySetup.intents.shadowComparison": "Technical comparison",
  "fiscalGatewaySetup.intents.sourceProducts.coopCompatibility": "Coop Platform",
  "fiscalGatewaySetup.intents.sourceProducts.externalSystem": "External POS or system",
  "fiscalGatewaySetup.intents.sourceProducts.tableService": "A3 Table Service",
  "fiscalGatewaySetup.intents.technicalDetails": "Technical details",
  "fiscalGatewaySetup.intents.title": "Payments and Receipts",
  "fiscalGatewaySetup.labels.backend": "Backend",
  "fiscalGatewaySetup.labels.compared": "Compared",
  "fiscalGatewaySetup.labels.config": "Config",
  "fiscalGatewaySetup.labels.directoryHash": "Directory hash",
  "fiscalGatewaySetup.labels.execution": "Execution",
  "fiscalGatewaySetup.labels.idempotency": "Idempotency:",
  "fiscalGatewaySetup.labels.input": "Input",
  "fiscalGatewaySetup.labels.items": "Items",
  "fiscalGatewaySetup.labels.lastResolved": "Last resolved",
  "fiscalGatewaySetup.labels.manifest": "Manifest",
  "fiscalGatewaySetup.labels.mirrored": "Mirrored",
  "fiscalGatewaySetup.labels.payloadHash": "Payload hash:",
  "fiscalGatewaySetup.labels.priority": "Priority",
  "fiscalGatewaySetup.labels.productHash": "Product hash",
  "fiscalGatewaySetup.labels.projectionHash": "Projection hash",
  "fiscalGatewaySetup.labels.reason": "Reason",
  "fiscalGatewaySetup.labels.receiptBundle": "Receipt bundle:",
  "fiscalGatewaySetup.labels.revision": "Revision",
  "fiscalGatewaySetup.nav.compatibility": "Compatibility",
  "fiscalGatewaySetup.nav.dataImport": "Data import",
  "fiscalGatewaySetup.nav.evidence": "Evidence",
  "fiscalGatewaySetup.nav.fiscalIntents": "Payments and Receipts",
  "fiscalGatewaySetup.nav.health": "Health",
  "fiscalGatewaySetup.nav.integrations": "POS/Register Connection",
  "fiscalGatewaySetup.nav.menuProducts": "Menu and Products",
  "fiscalGatewaySetup.nav.orderRoute": "Order Route",
  "fiscalGatewaySetup.nav.overview": "Overview",
  "fiscalGatewaySetup.nav.paymentsReceipts": "Payments and Receipts",
  "fiscalGatewaySetup.nav.places": "Places",
  "fiscalGatewaySetup.nav.productName": "A3 Venue Bridge",
  "fiscalGatewaySetup.nav.productTagline": "POS/register integration gateway for venue operations",
  "fiscalGatewaySetup.nav.publications": "Publications",
  "fiscalGatewaySetup.nav.rollout": "Rollout",
  "fiscalGatewaySetup.nav.routes": "Routes",
  "fiscalGatewaySetup.nav.shortConnection": "Connect",
  "fiscalGatewaySetup.nav.shortEvidence": "Evidence",
  "fiscalGatewaySetup.nav.shortHealth": "Health",
  "fiscalGatewaySetup.nav.shortMenu": "Menu",
  "fiscalGatewaySetup.nav.shortOverview": "Home",
  "fiscalGatewaySetup.nav.shortPayments": "Payments",
  "fiscalGatewaySetup.nav.shortPlaces": "Places",
  "fiscalGatewaySetup.nav.shortRoute": "Route",
  "fiscalGatewaySetup.overview.cards.drift": "Compare issues",
  "fiscalGatewaySetup.overview.cards.invalid": "Needs review",
  "fiscalGatewaySetup.overview.cards.product": "Product",
  "fiscalGatewaySetup.overview.cards.runtime": "Runtime",
  "fiscalGatewaySetup.overview.description": "Runtime boundary, mounted API prefixes and latest order/payment operations.",
  "fiscalGatewaySetup.overview.errors.loadStatus": "Failed to load Venue Bridge status",
  "fiscalGatewaySetup.overview.featureFlagFallbackDescription": "Technical Venue Bridge overview is shown because the merchant setup dashboard rollout flag is disabled.",
  "fiscalGatewaySetup.overview.latestIntents": "Latest operations",
  "fiscalGatewaySetup.overview.mountedRoutes": "Mounted routes",
  "fiscalGatewaySetup.overview.noMountedRoutes": "No mounted routes reported.",
  "fiscalGatewaySetup.overview.phase2Description": "Setup, daily order/payment routes and advanced evidence use one shared Venue Bridge surface.",
  "fiscalGatewaySetup.overview.phase2Eyebrow": "Setup dashboard",
  "fiscalGatewaySetup.overview.title": "Venue Bridge Overview",
  "fiscalGatewaySetup.operations.backendHealth.detail": "Backend connection tests and connector health for the selected merchant scope.",
  "fiscalGatewaySetup.operations.backendHealth.title": "Backend health",
  "fiscalGatewaySetup.operations.failedReceipts.detail": "Receipt requests with payment close, route or backend comparison problems.",
  "fiscalGatewaySetup.operations.failedReceipts.title": "Failed receipts",
  "fiscalGatewaySetup.operations.publicationIssues.detail": "Catalog publication blockers before live receipt execution.",
  "fiscalGatewaySetup.operations.publicationIssues.title": "Publication issues",
  "fiscalGatewaySetup.operations.recentReceipts.detail": "Latest receipt requests received by Venue Bridge.",
  "fiscalGatewaySetup.operations.recentReceipts.title": "Recent receipts",
  "fiscalGatewaySetup.operations.retryQueue.detail": "Receipt sending or reconciliation items that need safe retry or review.",
  "fiscalGatewaySetup.operations.retryQueue.title": "Retry queue",
  "fiscalGatewaySetup.operations.serviceAlerts.detail": "Runtime, compatibility mirror or service issues that may affect receipt processing.",
  "fiscalGatewaySetup.operations.serviceAlerts.title": "Service alerts",
  "fiscalGatewaySetup.operations.status.attention": "Action needed",
  "fiscalGatewaySetup.operations.status.ready": "Ready",
  "fiscalGatewaySetup.operations.status.review": "Review",
  "fiscalGatewaySetup.publications.counts.active": "{count} active",
  "fiscalGatewaySetup.publications.counts.blockers": "{count} blockers",
  "fiscalGatewaySetup.publications.description": "Catalog dry-run, issue review, compare, approve and activation.",
  "fiscalGatewaySetup.publications.dryRun.description": "Activation endpoints remain protected by product approval policy.",
  "fiscalGatewaySetup.publications.dryRun.title": "Dry-run",
  "fiscalGatewaySetup.publications.errors.actionFailed": "{action} failed",
  "fiscalGatewaySetup.publications.errors.approvalRequired": "Approval is required before this action can run.",
  "fiscalGatewaySetup.publications.errors.dryRunFailed": "Dry-run failed",
  "fiscalGatewaySetup.publications.errors.invalidJson": "Publication input JSON is invalid",
  "fiscalGatewaySetup.publications.errors.load": "Failed to load publications",
  "fiscalGatewaySetup.publications.errors.requestFailed": "Publication request failed",
  "fiscalGatewaySetup.publications.fields.event": "Event",
  "fiscalGatewaySetup.publications.fields.merchant": "Merchant",
  "fiscalGatewaySetup.publications.fields.provider": "Provider",
  "fiscalGatewaySetup.publications.fields.publicationInput": "Publication input",
  "fiscalGatewaySetup.publications.fields.status": "Status",
  "fiscalGatewaySetup.publications.notices.approved": "Publication approved.",
  "fiscalGatewaySetup.publications.notices.activated": "Publication activated.",
  "fiscalGatewaySetup.publications.notices.compare": "Compare {status}.",
  "fiscalGatewaySetup.publications.notices.dryRunCompleted": "Dry-run completed.",
  "fiscalGatewaySetup.publications.notices.dryRunStatus": "Dry-run {status}.",
  "fiscalGatewaySetup.publications.notices.updated": "Publication updated",
  "fiscalGatewaySetup.publications.title": "Publications",
  "fiscalGatewaySetup.rollout.counts.activeConnectors": "Active connectors",
  "fiscalGatewaySetup.rollout.counts.backfill": "Backfill",
  "fiscalGatewaySetup.rollout.counts.executeRoutes": "Execute routes",
  "fiscalGatewaySetup.rollout.counts.mirrorIssues": "Mirror issues",
  "fiscalGatewaySetup.rollout.counts.passedTests": "Passed tests",
  "fiscalGatewaySetup.rollout.counts.shadowEvidence": "Test evidence",
  "fiscalGatewaySetup.rollout.description": "Release gates for read-only deploy, backfill, test mode, live route and rollback.",
  "fiscalGatewaySetup.rollout.errors.load": "Failed to load production rollout status",
  "fiscalGatewaySetup.rollout.errors.requestFailed": "Rollout status failed",
  "fiscalGatewaySetup.rollout.evidence.description": "Counts backing the rollout decision",
  "fiscalGatewaySetup.rollout.evidence.title": "Evidence",
  "fiscalGatewaySetup.rollout.fields.channel": "Channel",
  "fiscalGatewaySetup.rollout.fields.directoryMerchant": "Directory merchant",
  "fiscalGatewaySetup.rollout.fields.merchantRef": "Merchant ref",
  "fiscalGatewaySetup.rollout.flags.allSyncedMerchants": "All synced merchants",
  "fiscalGatewaySetup.rollout.flags.dbBoundary": "DB boundary {state}",
  "fiscalGatewaySetup.rollout.flags.enforced": "enforced",
  "fiscalGatewaySetup.rollout.flags.executeChdMerchants": "Execute CHD merchants",
  "fiscalGatewaySetup.rollout.flags.legacyRollbackMerchants": "Legacy rollback merchants",
  "fiscalGatewaySetup.rollout.flags.merchantCount": "{count} merchant scopes",
  "fiscalGatewaySetup.rollout.flags.notEnforced": "not enforced",
  "fiscalGatewaySetup.rollout.flags.rolloutMerchants": "Rollout merchants",
  "fiscalGatewaySetup.rollout.flags.shadowMerchants": "Test-mode merchants",
  "fiscalGatewaySetup.rollout.flags.title": "Runtime Flags",
  "fiscalGatewaySetup.rollout.flags.description": "Non-secret rollout env scope",
  "fiscalGatewaySetup.rollout.gates.description": "Current gate decision for the selected rollout scope",
  "fiscalGatewaySetup.rollout.gates.title": "Release Gates",
  "fiscalGatewaySetup.rollout.placeholders.channel": "main",
  "fiscalGatewaySetup.rollout.placeholders.directoryMerchant": "dir-...",
  "fiscalGatewaySetup.rollout.placeholders.merchantRef": "merchant-...",
  "fiscalGatewaySetup.rollout.scope.description": "Channel gate context. Merchant and Place scope comes from synced setup.",
  "fiscalGatewaySetup.rollout.scope.title": "Scope",
  "fiscalGatewaySetup.rollout.summary.environment": "Environment",
  "fiscalGatewaySetup.rollout.summary.generated": "Generated",
  "fiscalGatewaySetup.rollout.summary.releaseGate": "Release gate",
  "fiscalGatewaySetup.rollout.summary.uiMode": "UI mode",
  "fiscalGatewaySetup.rollout.title": "Production Rollout",
  "fiscalGatewaySetup.rollout.uiMode.mutable": "Mutable",
  "fiscalGatewaySetup.rollout.uiMode.readOnly": "Read-only",
  "fiscalGatewaySetup.routes.advanced.additionalConfig": "Additional route config",
  "fiscalGatewaySetup.routes.advanced.backend": "Backend",
  "fiscalGatewaySetup.routes.advanced.execution": "Execution",
  "fiscalGatewaySetup.routes.advanced.hide": "Hide advanced settings",
  "fiscalGatewaySetup.routes.advanced.liveExecution": "Live route",
  "fiscalGatewaySetup.routes.advanced.mode": "Mode",
  "fiscalGatewaySetup.routes.advanced.priority": "Priority",
  "fiscalGatewaySetup.routes.advanced.shadowComparison": "Test alongside current setup",
  "fiscalGatewaySetup.routes.advanced.show": "Advanced settings",
  "fiscalGatewaySetup.routes.cards.shadowOnly": "Test only",
  "fiscalGatewaySetup.routes.check.description": "Check which active route would handle the next order or payment operation.",
  "fiscalGatewaySetup.routes.check.manualOverride": "Manual route check override",
  "fiscalGatewaySetup.routes.check.matched": "Matched",
  "fiscalGatewaySetup.routes.check.noRouteChecked": "No route checked yet",
  "fiscalGatewaySetup.routes.check.override": "Override: {value}",
  "fiscalGatewaySetup.routes.check.placeholderChannel": "channel",
  "fiscalGatewaySetup.routes.check.placeholderMerchantOverride": "merchant ref override",
  "fiscalGatewaySetup.routes.check.selectScopeFirst": "Select route scope first",
  "fiscalGatewaySetup.routes.check.title": "Route check",
  "fiscalGatewaySetup.routes.check.via": "{label} via {connector}",
  "fiscalGatewaySetup.routes.description": "Choose where each Merchant, Place or channel sends order, payment and fiscal operations.",
  "fiscalGatewaySetup.routes.errors.approvalRequired": "Approval is required before this route change can run.",
  "fiscalGatewaySetup.routes.errors.checkRouting": "Failed to check order route",
  "fiscalGatewaySetup.routes.errors.load": "Failed to load order routing",
  "fiscalGatewaySetup.routes.errors.requestFailed": "Routing request failed",
  "fiscalGatewaySetup.routes.errors.routeJsonInvalid": "Advanced route JSON is invalid",
  "fiscalGatewaySetup.routes.errors.saveRoute": "Failed to save order route",
  "fiscalGatewaySetup.routes.errors.updateRoute": "Failed to update route",
  "fiscalGatewaySetup.routes.fields.channel": "Channel",
  "fiscalGatewaySetup.routes.fields.directoryLocation": "Core Registry Place",
  "fiscalGatewaySetup.routes.fields.directoryMerchant": "Directory merchant",
  "fiscalGatewaySetup.routes.fields.initialState": "Initial state",
  "fiscalGatewaySetup.routes.fields.integration": "Integration",
  "fiscalGatewaySetup.routes.fields.locationRef": "Place ref",
  "fiscalGatewaySetup.routes.fields.merchantRef": "Merchant ref",
  "fiscalGatewaySetup.routes.fields.serviceMode": "Service mode",
  "fiscalGatewaySetup.routes.form.addDescription": "Start by testing alongside the current setup, then activate the live route after connector tests and approval.",
  "fiscalGatewaySetup.routes.form.addTitle": "Add route",
  "fiscalGatewaySetup.routes.form.connectionMerchantScope": "Selected merchant scope",
  "fiscalGatewaySetup.routes.form.connectionPlaceScope": "Selected Place scope",
  "fiscalGatewaySetup.routes.form.directoryProjectionReady": "Directory projection ready",
  "fiscalGatewaySetup.routes.form.manualScopeFallback": "Manual route scope fallback",
  "fiscalGatewaySetup.routes.form.merchantScope": "merchant scope",
  "fiscalGatewaySetup.routes.form.savedIntegration": "Saved integration",
  "fiscalGatewaySetup.routes.form.savedPlaceScope": "Saved Place route scope",
  "fiscalGatewaySetup.routes.form.savedRouteScope": "Saved merchant route scope",
  "fiscalGatewaySetup.routes.form.scope": "Scope: {scope}",
  "fiscalGatewaySetup.routes.form.scopeFromConnection": "Merchant and Place context comes from the selected integration.",
  "fiscalGatewaySetup.routes.form.selectIntegration": "Select integration",
  "fiscalGatewaySetup.routes.form.selectIntegrationScope": "select an integration",
  "fiscalGatewaySetup.routes.form.selectedRoute": "Selected route: {route}",
  "fiscalGatewaySetup.routes.notices.noActiveRoute": "No active route matched.",
  "fiscalGatewaySetup.routes.notices.resolved": "Resolved {routeRef}.",
  "fiscalGatewaySetup.routes.notices.routeAlreadyConfigured": "This route already matches the saved configuration.",
  "fiscalGatewaySetup.routes.notices.routeAlreadyStatus": "Route already had this status.",
  "fiscalGatewaySetup.routes.notices.routeSaved": "Order route saved.",
  "fiscalGatewaySetup.routes.notices.routeStatus": "Route {status}.",
  "fiscalGatewaySetup.routes.notices.updated": "Order routing updated",
  "fiscalGatewaySetup.routes.placeholders.channel": "table / delivery / default",
  "fiscalGatewaySetup.routes.placeholders.directoryId": "directory id",
  "fiscalGatewaySetup.routes.placeholders.merchantId": "merchant id",
  "fiscalGatewaySetup.routes.placeholders.optional": "optional",
  "fiscalGatewaySetup.routes.placeholders.optionalDirectoryId": "optional directory id",
  "fiscalGatewaySetup.routes.placeholders.optionalLocation": "optional Place",
  "fiscalGatewaySetup.routes.presets.chdLive.description": "Execute through the selected CHD/PM500 channel.",
  "fiscalGatewaySetup.routes.presets.chdLive.label": "CHD live",
  "fiscalGatewaySetup.routes.presets.chdShadow.description": "Compare CHD/PM500 execution without sending live register commands.",
  "fiscalGatewaySetup.routes.presets.chdShadow.label": "CHD test",
  "fiscalGatewaySetup.routes.presets.registerLive.description": "Execute fiscal receipts through A3 Fiscal Register.",
  "fiscalGatewaySetup.routes.presets.registerLive.label": "Register live",
  "fiscalGatewaySetup.routes.presets.registerShadow.description": "Compare routing with A3 Fiscal Register before go-live.",
  "fiscalGatewaySetup.routes.presets.registerShadow.label": "Register test",
  "fiscalGatewaySetup.routes.title": "Order route",
  "fiscalGatewaySetup.sections.boundary.description": "Venue Bridge setup shows product boundaries without implying ownership of payments, split formulas or external POS offline orders.",
  "fiscalGatewaySetup.sections.boundary.title": "Product boundaries",
  "fiscalGatewaySetup.sections.diagnostics.description": "For support operators and compliance troubleshooting.",
  "fiscalGatewaySetup.sections.diagnostics.title": "Advanced diagnostics",
  "fiscalGatewaySetup.sections.evidence.description": "Route matrix, publication compare and evidence are supporting tools for wider screens and support roles.",
  "fiscalGatewaySetup.sections.evidence.title": "Tablet and desktop tools",
  "fiscalGatewaySetup.sections.operations.description": "Daily order route, payment close, receipt status, retry and service health actions stay separate from first-time setup.",
  "fiscalGatewaySetup.sections.operations.title": "Health and route operations",
  "fiscalGatewaySetup.sections.setup.description": "Complete the merchant-facing steps before sending live Table Service orders and payment closes.",
  "fiscalGatewaySetup.sections.setup.title": "Setup",
  "fiscalGatewaySetup.setup.status.attention": "Needs setup",
  "fiscalGatewaySetup.setup.status.ready": "Ready",
  "fiscalGatewaySetup.setup.status.review": "Review",
  "fiscalGatewaySetup.setup.steps.businessProfile.detail": "Confirm business identity, taxpayer profile and Merchant/Place scope before routing operations.",
  "fiscalGatewaySetup.setup.steps.businessProfile.title": "Business and taxpayer profile",
  "fiscalGatewaySetup.setup.steps.catalogPublication.detail": "Publish or review the catalog record required by the selected receipt backend.",
  "fiscalGatewaySetup.setup.steps.catalogPublication.title": "Catalog publication",
  "fiscalGatewaySetup.setup.steps.fiscalBackend.detail": "Connect and test the POS, register or cash-register backend that will receive venue operations.",
  "fiscalGatewaySetup.setup.steps.fiscalBackend.title": "POS/register connection",
  "fiscalGatewaySetup.setup.steps.receiptReadback.detail": "Verify guests can see safe receipt status/readback after payment.",
  "fiscalGatewaySetup.setup.steps.receiptReadback.title": "Receipt status",
  "fiscalGatewaySetup.setup.steps.receiptRoute.detail": "Choose where Table Service orders, payment closes and receipt readback are sent for this merchant or venue.",
  "fiscalGatewaySetup.setup.steps.receiptRoute.title": "Order route",
  "fiscalGatewaySetup.setup.steps.sourceSystem.detail": "Configure the source that sends order/payment operations, such as Table Service, A3 Pay, Coop Platform or external POS.",
  "fiscalGatewaySetup.setup.steps.sourceSystem.title": "POS/register source",
  "fiscalGatewaySetup.sourceMode.a3Pos.detail": "A3 is acting as the POS source for this setup. Order/payment routing stays inside Venue Bridge.",
  "fiscalGatewaySetup.sourceMode.a3Pos.title": "A3 POS source of truth",
  "fiscalGatewaySetup.sourceMode.coopMode.detail": "Coop Platform remains source of truth for Coop split/allocation rules, participant rules and event/place/QR bindings.",
  "fiscalGatewaySetup.sourceMode.coopMode.title": "Coop mode source of truth",
  "fiscalGatewaySetup.sourceMode.externalPos.detail": "External POS remains source of truth for offline and table orders until an explicit A3 POS cutover.",
  "fiscalGatewaySetup.sourceMode.externalPos.title": "External POS source of truth",
  "fiscalGatewaySetup.sourceMode.tableServiceStandalone.detail": "A3 Table Service owns guest flow and product-local order, payment and fiscal refs for standalone operation.",
  "fiscalGatewaySetup.sourceMode.tableServiceStandalone.title": "Table Service standalone",
  "fiscalGatewaySetup.summary.description": "Connect Table Service and A3 Pay to the correct POS/register backend while keeping guest ordering, PSP execution and certified fiscal records in their owning products.",
  "fiscalGatewaySetup.summary.nextAction": "Next: {action}",
  "fiscalGatewaySetup.summary.progress": "{ready} of {total} steps ready",
  "fiscalGatewaySetup.summary.states.actionNeeded": "Action needed",
  "fiscalGatewaySetup.summary.states.backendOffline": "Backend offline",
  "fiscalGatewaySetup.summary.states.publicationRequired": "Publication required",
  "fiscalGatewaySetup.summary.states.readyForReceipts": "Ready for receipts",
  "fiscalGatewaySetup.summary.states.readyToTest": "Ready to test",
  "fiscalGatewaySetup.summary.states.routeSetupRequired": "Route setup required",
  "fiscalGatewaySetup.summary.states.serviceIssue": "Service issue",
  "fiscalGatewaySetup.summary.states.shadowMode": "Testing alongside current setup",
  "fiscalGatewaySetup.summary.states.underReview": "Under review",
  "fiscalGatewaySetup.summary.title": "Venue Bridge setup",
  "fiscalGatewaySetup.status.ACTIVATED": "Activated",
  "fiscalGatewaySetup.status.ACTIVE": "Active",
  "fiscalGatewaySetup.status.APPROVED": "Approved",
  "fiscalGatewaySetup.status.BLOCKED": "Blocked",
  "fiscalGatewaySetup.status.DELIVERED": "Delivered",
  "fiscalGatewaySetup.status.DISABLED": "Disabled",
  "fiscalGatewaySetup.status.DRAFT": "Draft",
  "fiscalGatewaySetup.status.DRIFT": "Drift",
  "fiscalGatewaySetup.status.ERROR": "Error",
  "fiscalGatewaySetup.status.ok": "OK",
  "fiscalGatewaySetup.status.FAILED": "Failed",
  "fiscalGatewaySetup.status.INVALID": "Invalid",
  "fiscalGatewaySetup.status.MATCHED": "Matched",
  "fiscalGatewaySetup.status.MATCH": "Match",
  "fiscalGatewaySetup.status.Mutable": "Mutable",
  "fiscalGatewaySetup.status.NOT_APPLICABLE": "Not applicable",
  "fiscalGatewaySetup.status.PASS": "Pass",
  "fiscalGatewaySetup.status.PASSED": "Passed",
  "fiscalGatewaySetup.status.PENDING": "Pending",
  "fiscalGatewaySetup.status.PUBLISHED": "Published",
  "fiscalGatewaySetup.status.Read-only": "Read-only",
  "fiscalGatewaySetup.status.STALE": "Stale",
  "fiscalGatewaySetup.status.SUPERSEDED": "Superseded",
  "fiscalGatewaySetup.status.SYNCED": "Synced",
  "fiscalGatewaySetup.status.VALID": "Valid",
  "fiscalGatewaySetup.status.VALIDATED": "Validated",
  "fiscalGatewaySetup.status.WARN": "Warn",
  "fiscalGatewaySetup.status.WARNING": "Warning",
  "fiscalGatewaySetup.statusLabels.draft": "Draft",
  "fiscalGatewaySetup.statusLabels.active": "Active",
  "fiscalGatewaySetup.statusLabels.disabled": "Disabled",
  "fiscalGatewaySetup.coopMirror.counts.conflicts": "Conflicts",
  "fiscalGatewaySetup.coopMirror.cards.subject": "Mirror subject",
  "fiscalGatewaySetup.coopMirror.counts.failed": "Failed",
  "fiscalGatewaySetup.coopMirror.counts.failedOutbox": "Failed outbox",
  "fiscalGatewaySetup.coopMirror.counts.pendingOutbox": "Pending outbox",
  "fiscalGatewaySetup.coopMirror.counts.stale": "Stale",
  "fiscalGatewaySetup.coopMirror.counts.synced": "Synced",
  "fiscalGatewaySetup.coopMirror.description": "Outbox delivery and compatibility read-model sync for Venue Bridge-owned configuration.",
  "fiscalGatewaySetup.coopMirror.errors.import": "Failed to import compatibility mirror events",
  "fiscalGatewaySetup.coopMirror.errors.load": "Failed to load compatibility mirror status",
  "fiscalGatewaySetup.coopMirror.errors.requestFailed": "Compatibility mirror request failed",
  "fiscalGatewaySetup.coopMirror.fields.merchantRef": "Merchant ref",
  "fiscalGatewaySetup.coopMirror.importFinished": "Compatibility mirror import finished",
  "fiscalGatewaySetup.coopMirror.needAttention": "{count} need attention",
  "fiscalGatewaySetup.coopMirror.notices.importResult": "Imported {processed} event(s): {synced} synced, {stale} stale, {conflicts} conflicts, {failed} failed.",
  "fiscalGatewaySetup.coopMirror.outbox.title": "Recent outbox events",
  "fiscalGatewaySetup.coopMirror.placeholders.merchantId": "merchant id",
  "fiscalGatewaySetup.coopMirror.scope.description": "Filter by merchant ref when triaging stale or conflicting projections.",
  "fiscalGatewaySetup.coopMirror.scope.title": "Mirror scope",
  "fiscalGatewaySetup.coopMirror.title": "Compatibility Mirror"
} as const;

export default fiscalGatewaySetupEn;
